import React from "react";
import { Dialog } from "@mui/material";
import styles from "./index.module.css";
import greenCheck from "../../assets/greenCheck.png";

const ReferralSuccess = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: styles.dialogPaper,
      }}
    >
      <div className={styles.content}>
        <img
          src={greenCheck}
          alt="Success"
          className={styles.icon}
        />
        <p className={styles.message}>
          Your form has been submitted.
          <br />
          Our academic counselor will be in touch with your referral soon.
        </p>
        <button className={styles.closeButton} onClick={onClose}>
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default ReferralSuccess;
